module.exports = __webpack_public_path__ + "static/media/machobanners.f2a72bf3.png";